module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Murder on the Orion Express")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Gareth Vaughn")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a41"
    }
  }, [_vm._v("Part 1: The Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a42"
    }
  }, [_vm._v("Chapter 1: An Important Event at the Hjerson University")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/007#a43"
    }
  }, [_vm._v("Chapter 2: The Orion Express")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/008#a44"
    }
  }, [_vm._v("Chapter 3: Hercula Refuses to Mingle")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Disturbances in the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Suicide")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Really Suicide?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Deceased")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Whealtech Selfdrive Cars Suit")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: The Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: The Evidence of the Threat")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Evidence of the Audio Media Specialist")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Evidence of the Aunt")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Evidence of the CEO")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Evidence of the Night Shift")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/019#a56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Evidence of the Turned Room")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/020#a57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Evidence of the Tour Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/021#a58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Evidence of the Barista")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/022#a59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Evidence of the DMV Worker")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/023#a60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Evidence of the Captain")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/024#a61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Evidence of the Widow")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/025#a62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Evidence of the Oil Executive")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/026#a63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Evidence of the Nonprofit Director")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/027#a64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Summary of the Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/028#a65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Evidence of the Returned Data")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/029#a66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Hercula Perry Sits Back and Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/029#a67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Who Could Have Done It?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/030#a68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Terren’s Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/031#a69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Certain Deceased People")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/032#a70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Generosity of the Thief")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/033#a71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Identity of the Tenth Person")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/034#a72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Simon’s Surprising Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/035#a73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Hercula Proposes Two Possibilities")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/036#a74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Orion Express, Again")]), _c('a', {
    attrs: {
      "href": "#/#a40"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "ncx58"
    }
  }), _c('a', {
    attrs: {
      "id": "a40"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0